import { AxiosResponse } from "axios";
import { Base } from "@tt-app/api/base";
import { API_ENDPOINTS } from "@tt-app/constants/api";
import { LimitedModeDetails, LiveState, SessionDetails } from "@tt-app/store/terratalkLive/types";
import { LimitedModeDetailsPayload, StatePayload } from "@tt-app/models";

const {
  TERRATALK_LIVE: { LIMITED_MODE, STATE, SESSION }
} = API_ENDPOINTS;

class TerratalkLive extends Base {
  async limitedModeDetails(
    payload: LimitedModeDetailsPayload
  ): Promise<AxiosResponse<LimitedModeDetails>> {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };

    const sessionId = payload.sessionId;
    const limitedModeId = payload.limitedModeId;

    return this.httpClient.get(`${LIMITED_MODE}${sessionId}/limited-mode/${limitedModeId}/`, {
      headers
    });
  }

  stateRequest?: Promise<AxiosResponse<LiveState>> = undefined;

  async state(payload: StatePayload): Promise<AxiosResponse<LiveState>> {
    if (this.stateRequest) throw new Error("previous request still in progress");

    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };

    const currentSessionId = payload.currentSessionId;
    const deviceUuid = payload.deviceUuid;
    const force = payload.force;

    this.stateRequest = this.httpClient.post(
      STATE,
      { currentSessionId, deviceId: deviceUuid, force },
      { headers }
    );

    return new Promise((resolve, reject) => {
      this.stateRequest
        ?.then(() => {
          resolve(this.stateRequest);
        })
        .catch(error => {
          reject(error);
        })
        .finally(() => {
          this.stateRequest = undefined;
        });
    });
  }

  async session(payload: any): Promise<AxiosResponse<SessionDetails>> {
    const headers = { ...this.buildAuthHeaders(payload.authInfo), ...this.buildLangHeader() };

    const sessionId = payload.sessionId;

    return this.httpClient.get(`${SESSION}${sessionId}/`, { headers });
  }
}

export { TerratalkLive };
